export function dateRange(startDate: Date, endDate: Date): Date[] {
  const dates: Date[] = [];

  let currentDate = new Date(
    startDate.getFullYear(),
    startDate.getMonth(),
    startDate.getDate()
  );

  while (currentDate <= endDate) {
    dates.push(currentDate);

    currentDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate() + 1
    );
  }

  return dates;
}

export function daysOfMonth(date: Date): Date[] {
  return dateRange(firstDayOfMonth(date), lastDayOfMonth(date));
}

export function daysInMonth(month, year): number {
  return new Date(year, month + 1, 0).getDate();
}

export function firstDayOfMonth(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), 1);
}

export function lastDayOfMonth(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0);
}